import { Icon, List } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import type { InsightInstrumentPrompt } from 'lib-analytics-types';

import styles from './instrumentInsightsPrompts.module.scss';

type InstrumentInsightsPromptsProps = {
  /** The list of prompts. */
  prompts: readonly InsightInstrumentPrompt[];
  /** Called when a prompt is selected. */
  onSelectPrompt: (prompt: InsightInstrumentPrompt) => void;
};

export const InstrumentInsightsPrompts = ({
  prompts,
  onSelectPrompt,
}: InstrumentInsightsPromptsProps): JSX.Element => {
  return (
    <List className={styles.list}>
      {prompts.map((prompt) => (
        <List.Item
          key={prompt.id}
          className={styles.listItem}
          variant="large"
          title={prompt.title}
          titleSecondary={prompt.description}
          contentLeft={
            <Icon
              name={prompt.icon ?? 'ai'}
              color={colors.purple[700]}
              size={24}
              className={styles.icon}
            />
          }
          onClick={() => onSelectPrompt(prompt)}
        />
      ))}
    </List>
  );
};
